import { cloneCharacterRuntimeState } from '../character/runtime-state';
import type { CharacterRuntimeState } from '../character/runtime-state';
import type { BattlePhase } from './battle-phase';
import { cloneTrapSpatialState } from '../physics/spatial-types';
import type { TrapSpatialState } from '../physics/spatial-types';
import { cloneCombatTrapRuntime, cloneComboRuntime } from '../combat/systems';
import type { CombatTrapRuntime, ComboRuntime, RoundResult } from '../combat/systems';

export interface BattleRuntimeState {
  logicalFrame: number;
  battlePhase: BattlePhase;
  timerFrames: number;
  hitstopFrames: number;
  characters: [CharacterRuntimeState, CharacterRuntimeState];
  traps: TrapSpatialState[];
  combatTraps: CombatTrapRuntime[];
  combos: ComboRuntime[];
  roundResult: RoundResult | null;
  nextAttackInstanceSequence: number;
  nextComboSequence: number;
  nextEffectSequence: number;
  nextTrapSequence: number;
  nextCinematicSequence: number;
  pendingCinematics: CinematicEntry[];
  activeCinematicId: string | null;
  transientRequests: string[];
}

export interface CinematicEntry {
  readonly cinematicId: string;
  readonly playerSlot: 0 | 1;
  readonly attackInstanceId: string;
}

export const cloneBattleRuntimeState = (source: Readonly<BattleRuntimeState>): BattleRuntimeState => ({
  logicalFrame: source.logicalFrame,
  battlePhase: source.battlePhase,
  timerFrames: source.timerFrames,
  hitstopFrames: source.hitstopFrames,
  characters: [
    cloneCharacterRuntimeState(source.characters[0]),
    cloneCharacterRuntimeState(source.characters[1]),
  ],
  traps: source.traps.map(cloneTrapSpatialState),
  combatTraps: source.combatTraps.map(cloneCombatTrapRuntime),
  combos: source.combos.map(cloneComboRuntime),
  roundResult: source.roundResult === null ? null : Object.freeze({ ...source.roundResult }),
  nextAttackInstanceSequence: source.nextAttackInstanceSequence,
  nextComboSequence: source.nextComboSequence,
  nextEffectSequence: source.nextEffectSequence,
  nextTrapSequence: source.nextTrapSequence,
  nextCinematicSequence: source.nextCinematicSequence,
  pendingCinematics: source.pendingCinematics.map((entry) => ({ ...entry })),
  activeCinematicId: source.activeCinematicId,
  transientRequests: [...source.transientRequests],
});
